import { QueryKey } from '@tanstack/react-query';

export const isValid = (queryKey: QueryKey) => {
	if (
		queryKey.length === 0 ||
		queryKey.includes(undefined) ||
		queryKey.includes(null) ||
		queryKey.includes('')
	) {
		return false;
	}

	return true;
};
